// import React from 'react';
// import { Link } from 'react-router-dom';
// import Section from '../Section';
// import Breadcrumb from '../Breadcrumb';
// import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
// import { Icon } from '@iconify/react';
// import Spacing from '../Spacing';
// import Post from '../Post';
// import Sidebar from '../Sidebar';
// import AuthorWidget from '../Widget/AuthorWidget';
// import CommentsWidget from '../Widget/CommentsWidget';
// import ReplyWidget from '../Widget/ReplyWidget';
// import { pageTitle } from '../../helpers/PageTitle';
// const tags = [
//   { tag: 'Emergency', href: '/blog/blog-details' },
//   { tag: 'Pediatric', href: '/blog/blog-details' },
//   { tag: 'Cardiology', href: '/blog/blog-details' },
//   { tag: 'Psychiatry', href: '/blog/blog-details' },
//   { tag: 'Others', href: '/blog/blog-details' },
// ];
// const relatedBlog = [
//   {
//     title:
//       'The Importance of Mental Health: Understanding and Managing Anxiety Disorders',
//     thumbUrl: '/images/blog/post_1.jpeg',
//     date: '3/2/2024',
//     btnText: 'Read More',
//     href: '/blog/blog-details',
//   },
//   {
//     title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
//     thumbUrl: '/images/blog/post_2.jpeg',
//     date: 'March 11',
//     btnText: 'Learn More',
//     href: '/blog/blog-details',
//   },
//   {
//     title: 'Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle',
//     thumbUrl: '/images/blog/post_3.jpeg',
//     date: 'March 9',
//     btnText: 'Learn More',
//     href: '/blog/blog-details',
//   },
// ];

// export default function BlogDetails() {
//   pageTitle('Blog Details');
//   return (
//     <>
//       <Section topMd={170} bottomMd={54} bottomLg={54}>
//         <Breadcrumb title="What is hyper-hypothermia unit?" />
//       </Section>
//       <div className="container">
//         <div className="cs_blog_details_info">
//           <div className="cs_blog_details_info_left">
//             <div className="cs_blog_details_tags">
//               {tags.map((item, index) => (
//                 <Link key={index} to={item.href}>
//                   {item.tag}
//                 </Link>
//               ))}
//             </div>
//             <div className="cs_blog_details_date">
//               Feb 3, 2024 | Mercury Healthcare
//             </div>
//           </div>
//           <div className="cs_social_links_wrap">
//             <h2>Share:</h2>
//             <div className="cs_social_links">
//               <Link to="/">
//                 <Icon icon="fa-brands:facebook-f" />
//               </Link>
//               <Link to="/">
//                 <Icon icon="fa-brands:linkedin-in" />
//               </Link>
//               <Link to="/">
//                 <Icon icon="fa-brands:twitter" />
//               </Link>
//             </div>
//           </div>
//         </div>
//         <Spacing md="55" />
//         <img
//           src="/images/blog/hyper-hypothermia unit main Image.jpg"
//           alt="Blog Details"
//           className="w-100 cs_radius_20"
//         />
//         <Spacing md="90" lg="50" />
//         <div className="row">
//           <div className="col-lg-12">
//             <div className="cs_blog_details">
//               <h2>Definition of the Hyper-Hypothermia unit.</h2>
//               <p> A unit that manages body temperature until it returns to the normal levels using electronically regulated blankets and Pads.
//                 Normally it is found in every medical hospital and OT (Operation Theater).
//                 <br />
//                 <br />
//                 The normal temperature of any human body is around 98.6°F (Fahrenheit), or 37°C (Celsius)
//                 is considered to be a normal and healthy body temperature. In real life, there are
//                 different situations where body temperature varies with the range of activity that
//                 humans exercise i.e, running, eating, drinking, and women’s menses can lower your body temperature.
//                 According to the study, body temperature is typically lowest at 3 a.m and its highest at 6 p.m
//                 but it found in the range of 97.8°F (36.5°C) and 99°F (37.2°C).
//               </p>
//               <h2>The Purpose </h2>
//               <p>The hyper-hypothermia unit acts as a regulator for your body temperature which severely
//                 increases or decreased above the range of standard body temperature which can be found
//                 in an abnormal situation and it leads to medical emergencies. </p>
//               <h3>Below are the common impacts of hyper-hypothermia.</h3>
//               <ol>
//                 <li>
//                   <b>Exposure to extreme heat or cold </b>
//                 </li>
//                 <li>
//                   <b>Infections and Reactions </b>
//                 </li>
//                 <li>
//                   <b>Certain tumours</b>
//                 </li>
//                 <li>
//                   <b>Abnormal reaction to anaesthesia. </b>
//                 </li>
//                 <li>
//                   <b>Dehydration </b>
//                 </li>
//                 <li>
//                   <b>Surgeries related to heart and lung</b>
//                 </li>
//               </ol>
//               <p>
//                 There are certain standards which a hyper-hypothermia unit should maintain that is not to
//                 increase the temperature above 105.8°F (41°C) are required medical emergencies
//                 and the temperature above 109.4°F (43°C) will usually not survive.  <br /> <br />
//                 In today’s technologically advanced world, there are companies like Mercury Healthcare
//                 and Soma Medical Parts that provide authorised and accurate Units that can be very
//                 helpful for medical emergencies as well as other requirements to maintain humans body temperature.<br />
//                 <br />
//                 Among these, Mercury Healthcare stands out as the premier manufacturer and supplier of
//                 Hyper-Hypothermia units in India, offering state-of-the-art technology and
//                 unparalleled reliability in temperature regulation solutions.
//               </p>

//             </div>
//             <Spacing md="85" />

//           </div>

//         </div>

//       </div>

//     </>
//   );
// }

import React from "react";
import { Link, useParams } from "react-router-dom";
import Section from "../Section";
import Breadcrumb from "../Breadcrumb";
import { Icon } from "@iconify/react";
import Spacing from "../Spacing";
import { pageTitle } from "../../helpers/PageTitle";
import blogData from "../Data/data";
import { Helmet } from "react-helmet";

export default function BlogDetails() {
  const { blogUrl  } = useParams(); // Get the dynamic blog ID from URL
  const blog = blogData.find((item) => item.href === blogUrl ); // Find the blog by ID

  if (!blog) {
    return <h2>Blog not found</h2>; // Handle invalid blog ID
  }

  pageTitle(blog.title);

  return (
    <>
      {/* Dynamic Meta Tags */}
      <Helmet>
        <title>{blog.meta.title}</title>
        <meta
          name="keyword"
          content={blog.meta.keywords}
        />
        <meta name="description" content={blog.meta.description} />
      </Helmet>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={blog.breadcrumb.title} />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            {/* <div className="cs_blog_details_tags">
              {blog.tags?.map((item, index) => (
                <Link key={index} to={item.href}>
                  {item.tag}
                </Link>
              ))}
            </div> */}
            <div className="cs_blog_details_date">
              {/* {blog.date} |*/}
               {blog.author} 
            </div>
          </div>
          <div className="cs_social_links_wrap">
            <h2>Share:</h2>
            <div className="cs_social_links">
              {blog.socialLinks?.map((item, index) => (
                <Link key={index} to={item.href}>
                  <Icon icon={item.icon} />
                </Link>
              ))}
            </div>
          </div>
        </div>
        <Spacing md="55" />
        <img
          src={blog.bannerImage}
          alt={blog.title}
          className="w-100 cs_radius_20"
        />
        <Spacing md="90" lg="50" />
        <div className="row">
          <div className="col-lg-12">
            <div className="cs_blog_details">
              {blog.content?.map((section, index) => (
                <div key={index}>
                  <h2>{section.heading}</h2>
                  <p>{section.text}</p>
                  {section.list && (
                    <ol>
                      {section.list.map((item, listIndex) => (
                        <li key={listIndex}>
                          <b>{item}</b>
                        </li>
                      ))}
                    </ol>
                  )}
                </div>
              ))}
            </div>
            <Spacing md="85" />
          </div>
        </div>
      </div>
    </>
  );
}
